import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-shared';
import { PrepopulateData } from 'projects/bis-shared/src/lib/dynamic-forms/dynamic-form-inputs/postal-code-prepopulate/prepopulate-data';
import { WillHandleErrorMessagingOption } from '../../../utility/http-options';

@Injectable()
export class PostalCodePrepopulateService {
  constructor(protected httpClient: HttpClient, protected sharedApiUrls: ApiUrls) {}

  getPrepopulateData(postalCode: string): Observable<PrepopulateData> {
    const postalCodeUrl = this.sharedApiUrls.postalCodePrepopulate.get(postalCode);
    return this.httpClient.get<PrepopulateData>(postalCodeUrl, WillHandleErrorMessagingOption);
  }
}
